<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmTariffPressure from 'src/components/EnergyMonitoring/sections/EmTariffPressure.svelte';
	import { getControlsForEnergyConfig } from 'src/components/Dashboards/dash-energy-period';
	import type { DashEnergyWidgetConfig } from 'src/components/Dashboards/dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig | undefined;
	export let staticPreview = false;

	$: config = energyConfig ?? { period: 'live' };
	$: controls = getControlsForEnergyConfig(config);
</script>

<EmTariffPressure {staticPreview} {controls} periodId={config.period} />
